module.exports = __webpack_public_path__ + "static/media/cq_avanti b.fffb3f7f.svg";